import { FC, useState } from 'react';

import { Close } from '@mui/icons-material';
import { Button } from '@mui/material';
import { Formik } from 'formik';
import { useNavigate } from 'react-router-dom';

import { useParams } from '@redwoodjs/router';

import { Flex } from 'src/components/Flex';
import { FieldInput } from 'src/components/FormikComponents';
import { ModalBox } from 'src/components/ModalContent/Modal';

export const CancelCreditNoteItem: FC = () => {
    const { id } = useParams();
    const [showModal, setShowModal] = useState(false);
    const navigate = useNavigate();

    // TODD: use id from useParams and get cancel credit note mutation

    return (
        <>
            <Flex
                justifyContent="center"
                alignItems="center"
                color="white"
                bgcolor="#F39E4E"
                borderRadius="4px"
                padding="8px"
                sx={{ cursor: 'pointer' }}
                onClick={() => setShowModal(true)}
            >
                <Close height="24px" width="24px" />
            </Flex>
            {showModal && (
                <ModalBox
                    handleCloseModal={() => setShowModal(false)}
                    open={showModal}
                    title="Confirm Credit Note Cancellation"
                >
                    <Formik
                        initialValues={{
                            reason: '',
                            raiseCreditNote: 'YES',
                        }}
                        onSubmit={async ({ reason, raiseCreditNote }) => {
                            // submit credit note cancellation item using mutation fetched
                        }}
                        validationSchema={() => {
                            // build validation schema
                        }}
                    >
                        {({ handleSubmit }) => (
                            <Flex gap="16px" flexDirection="column" padding="16px 8px">
                                <FieldInput
                                    name="reason"
                                    label="Reason for Cancelling"
                                    placeholder="Reason for Cancelling"
                                />
                                <Flex gap="8px">
                                    <Button onClick={() => setShowModal(false)} variant="main">
                                        Cancel
                                    </Button>
                                    <Button onClick={() => handleSubmit()} variant="main">
                                        Confirm
                                    </Button>
                                </Flex>
                            </Flex>
                        )}
                    </Formik>
                </ModalBox>
            )}
        </>
    );
};
